import React, { useState, useEffect } from "react";
import { Button, Container, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import HomePage from "../../Home";
import { VUsuariosStyle } from "./styles";
import TUsuarios from "./../TUsuarios";
import FUsuario from "./../FUsuarios";
import { useDispatch, useSelector } from "react-redux";
import { obtenerUsuariosAction } from "../../../ducks/usuariosDuck";
import BackDrop from "./../../../global/BackDrop";
import useApi from "./../../../hooks/useAPI";

export default function VProveedorUsuario() {
  const Clasess = VUsuariosStyle();
  const dispatch = useDispatch();
  const catalogoTipoUsuario = useApi("Catalog/TipoUsuario");
  const usuarios = useSelector(
    (store) => store.usuarios.array
  );
  
  const [openModal, setOpenModal] = useState(false);
  const [rowTarget, setRowTarget] = useState({});
  const [editar, setEditar] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [tipoUsuario, setTipoUsuario] = useState(0);

  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerUsuariosAction(tipoUsuario)).then((Reposne) => {
      setIsLoad(false);
    });
  }, [dispatch, tipoUsuario]);

  const handleOpen = () => {
    setOpenModal(!openModal);
    setEditar(false);
  };

  const onEditar = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(true);
    setOpenModal(!openModal);
  };

  const handleSelecTipoUsuario = (event) =>{
    setTipoUsuario(event.target.value);
  }
  
  return (
    <HomePage>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={Clasess.contentMargin}
        >
          <Grid item xs={3}>
          <FormControl variant="outlined" className={Clasess.formControl}>
              <InputLabel id="lTipoUsuario">Tipo Usuario</InputLabel>
              <Select
                labelId="lTipoUsuario"
                id="STipoUsuario"
                name="tipoUsuario"
                value={tipoUsuario}
                onChange={handleSelecTipoUsuario}
                label="Tipo Usuario"
              >
                <MenuItem value={0}>
                  {"Todos los usuarios"}
                </MenuItem>
                {catalogoTipoUsuario.map((item, index) => (
                  <MenuItem key={item.IdTipoUsuario} value={item.IdTipoUsuario}>
                    {item.Descripion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2} className={Clasess.flexEnd}>
            <Button variant="outlined" color="primary" onClick={handleOpen}>
              Nuevo usuario
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <TUsuarios rows={usuarios} onEditar={onEditar} />
          </Grid>
        </Grid>
        <FUsuario
          open={openModal}
          setOpen={setOpenModal}
          editar={editar}
          setEditar={setEditar}
          rowData={rowTarget}
        />
        <BackDrop open={isLoad} />
      </Container>
    </HomePage>
  );
}
